import React, { useEffect, useMemo, useRef, useState } from "react";
import UdrzbaDetailZakazky from "./UdrzbaDetailZakazky";
import * as XLSX from "xlsx";
import { apiJson } from "../../auth/authClient";

const LS_KEY = "pohrebka_udrzba_zakazky_v1";
const LAST_CREATED_KEY = "pohrebka_udrzba_last_created_id";

function readStoredUiState() {
  if (typeof window === "undefined") {
    return {
      query: "",
      stavFilter: "vse",
      platbaFilter: "vse",
      predplatneFilter: "vse",
      typPeceFilter: "vse",
      hrbitovFilter: "vse",
      sortBy: "dalsi_navsteva",
      sortDir: "asc",
      quickFilter: "vse",
    };
  }

  try {
    const raw = window.localStorage.getItem(LS_KEY);
    if (!raw) {
      return {
        query: "",
        stavFilter: "vse",
        platbaFilter: "vse",
        predplatneFilter: "vse",
        typPeceFilter: "vse",
        hrbitovFilter: "vse",
        sortBy: "dalsi_navsteva",
        sortDir: "asc",
        quickFilter: "vse",
      };
    }

    const parsed = JSON.parse(raw);
    return {
      query: typeof parsed?.query === "string" ? parsed.query : "",
      stavFilter: typeof parsed?.stavFilter === "string" ? parsed.stavFilter : "vse",
      platbaFilter: typeof parsed?.platbaFilter === "string" ? parsed.platbaFilter : "vse",
      predplatneFilter: typeof parsed?.predplatneFilter === "string" ? parsed.predplatneFilter : "vse",
      typPeceFilter: typeof parsed?.typPeceFilter === "string" ? parsed.typPeceFilter : "vse",
      hrbitovFilter: typeof parsed?.hrbitovFilter === "string" ? parsed.hrbitovFilter : "vse",
      sortBy: typeof parsed?.sortBy === "string" ? parsed.sortBy : "dalsi_navsteva",
      sortDir: typeof parsed?.sortDir === "string" ? parsed.sortDir : "asc",
      quickFilter: typeof parsed?.quickFilter === "string" ? parsed.quickFilter : "vse",
    };
  } catch {
    return {
      query: "",
      stavFilter: "vse",
      platbaFilter: "vse",
      predplatneFilter: "vse",
      typPeceFilter: "vse",
      hrbitovFilter: "vse",
      sortBy: "dalsi_navsteva",
      sortDir: "asc",
      quickFilter: "vse",
    };
  }
}

const API = "/api/udrzba";


function getMainServiceLabel(item) {
  const mainId = String(item?.hlavniSluzbaId || "").trim();
  const mainNameRaw = String(item?.hlavniSluzba || "").trim();
  const items = Array.isArray(item?.items) ? item.items : [];

  if (mainId) {
    const mainItem = items.find((x) => String(x?.cenikId || "").trim() === mainId);
    if (String(mainItem?.nazev || "").trim()) return String(mainItem.nazev).trim();
  }

  if (mainId === "public-balicek-4-plus-1" || mainNameRaw === "balicek_4_plus_1") {
    return "Základní péče o hrob – 4 návštěvy + 5. zdarma";
  }

  const firstNamedItem = items.find((x) => String(x?.nazev || "").trim());
  if (String(firstNamedItem?.nazev || "").trim()) return String(firstNamedItem.nazev).trim();

  if (mainNameRaw) return mainNameRaw;

  if (String(item?.zadaniPrace || "").trim()) return String(item.zadaniPrace).trim();

  const sluzby = Array.isArray(item?.sluzby)
    ? item.sluzby.map((x) => String(x || "").trim()).filter(Boolean)
    : [];
  if (sluzby.length) return sluzby.join(", ");

  return "";
}

function getPlanRangeLabel(item) {
  const dates = Array.isArray(item?.planNavstev)
    ? item.planNavstev.map((x) => String(x || "").slice(0, 10)).filter(Boolean)
    : [];

  if (!dates.length) return "-";
  if (dates.length === 1) return dates[0];

  const sorted = [...dates].sort();
  return `${sorted[0]} – ${sorted[sorted.length - 1]}`;
}
function periodicitaLabel(v) {
  const x = String(v || "").trim().toLowerCase();
  if (x === "mesicne") return "Měsíčně";
  if (x === "ctvrtletne") return "Čtvrtletně";
  if (x === "pulrocne") return "Půlročně";
  if (x === "rocne") return "Ročně";
  if (x === "dle_domluvy") return "Dle domluvy";
  return v || "-";
}

function csvEscape(value) {
  const s = String(value ?? "");
  return `"${s.replace(/"/g, '""')}"`;
}

function money(v) {
  return `${Number(v || 0).toLocaleString("cs-CZ")} Kč`;
}

const inputStyle = {
  width: "100%",
  padding: "10px 12px",
  borderRadius: 12,
  border: "1px solid #dbe3ee",
  fontSize: 14,
  background: "#ffffff",
  color: "#111827",
  outline: "none",
  boxSizing: "border-box",
  boxShadow: "0 1px 2px rgba(15,23,42,0.03)",
};

function quickBtnStyle(active) {
  return {
    padding: "7px 12px",
    borderRadius: 999,
    border: active ? "1px solid #2563eb" : "1px solid #dbe3ee",
    background: active ? "#eff6ff" : "#ffffff",
    color: active ? "#1d4ed8" : "#475569",
    fontWeight: active ? 700 : 600,
    cursor: "pointer",
    fontSize: 13,
    lineHeight: 1.2,
    boxShadow: active ? "0 1px 2px rgba(37,99,235,0.06)" : "0 1px 2px rgba(15,23,42,0.03)",
  };
}

function summaryCardStyle(active = false, clickable = false) {
  return {
    border: active ? "1px solid #2563eb" : "1px solid #e5e7eb",
    borderRadius: 12,
    background: active ? "#eff6ff" : "#ffffff",
    padding: 12,
    cursor: clickable ? "pointer" : "default",
    transition: "all 120ms ease",
    boxShadow: active ? "0 1px 2px rgba(37,99,235,0.08)" : "0 1px 2px rgba(15,23,42,0.03)",
  };
}

function rowActionBtnStyle(kind = "secondary") {
  if (kind === "primary") {
    return {
      padding: "7px 10px",
      borderRadius: 12,
      border: "1px solid #2563eb",
      background: "#eff6ff",
      color: "#1d4ed8",
      cursor: "pointer",
      fontWeight: 700,
      fontSize: 13,
      lineHeight: 1.2,
      boxShadow: "0 1px 2px rgba(37,99,235,0.08)",
    };
  }

  return {
    padding: "7px 10px",
    borderRadius: 10,
    border: "1px solid #dbe3ee",
    background: "#ffffff",
    color: "#334155",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 13,
    lineHeight: 1.2,
    boxShadow: "0 1px 2px rgba(15,23,42,0.03)",
  };
}

function subscriptionBadgeStyle(status) {
  const base = {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    border: "1px solid transparent",
    whiteSpace: "nowrap",
  };

  if (status === "aktivni") {
    return { ...base, background: "#ecfdf5", color: "#065f46", borderColor: "#a7f3d0" };
  }
  if (status === "konci_brzy") {
    return { ...base, background: "#fffbeb", color: "#92400e", borderColor: "#fde68a" };
  }
  if (status === "ceka_na_obnovu") {
    return { ...base, background: "#fef2f2", color: "#991b1b", borderColor: "#fecaca" };
  }
  if (status === "vyprselo") {
    return { ...base, background: "#fff1f2", color: "#9f1239", borderColor: "#fbcfe8" };
  }
  return { ...base, background: "#f3f4f6", color: "#374151", borderColor: "#d1d5db" };
}

function hrbitovBadgeStyle(v) {
  const x = String(v || "").trim().toLowerCase();
  const base = {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    border: "1px solid transparent",
    whiteSpace: "nowrap",
  };

  if (x === "český krumlov" || x === "cesky krumlov") {
    return { ...base, background: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" };
  }
  if (x === "křemže" || x === "kremze") {
    return { ...base, background: "#ecfdf5", color: "#065f46", borderColor: "#a7f3d0" };
  }
  if (x === "chvalšiny" || x === "chvalsiny") {
    return { ...base, background: "#fff7ed", color: "#c2410c", borderColor: "#fdba74" };
  }
  if (x === "hořice na šumavě" || x === "horice na sumave") {
    return { ...base, background: "#faf5ff", color: "#7e22ce", borderColor: "#d8b4fe" };
  }
  if (x === "zlatá koruna" || x === "zlata koruna") {
    return { ...base, background: "#fffbeb", color: "#92400e", borderColor: "#fde68a" };
  }

  return { ...base, background: "#f3f4f6", color: "#374151", borderColor: "#d1d5db" };
}

function subscriptionStatusLabel(status) {
  if (status === "aktivni") return "Aktivní";
  if (status === "konci_brzy") return "Končí brzy";
  if (status === "ceka_na_obnovu") return "Čeká na obnovu";
  if (status === "vyprselo") return "Vypršelo";
  return "-";
}

function typPeceLabel(v) {
  const x = String(v || "").trim().toLowerCase();
  if (x === "jednorazova") return "Jednorázová";
  if (x === "predplatne") return "Předplatné";
  if (x === "balicek" || x === "balicek_4x") return "Balíček";
  return x ? v : "-";
}

function typPeceBadgeStyle(v) {
  const x = String(v || "").trim().toLowerCase();
  const base = {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    border: "1px solid transparent",
    whiteSpace: "nowrap",
  };

  if (x === "jednorazova") {
    return { ...base, background: "#f3f4f6", color: "#374151", borderColor: "#d1d5db" };
  }
  if (x === "predplatne") {
    return { ...base, background: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" };
  }
  if (x === "balicek" || x === "balicek_4x") {
    return { ...base, background: "#ecfdf5", color: "#065f46", borderColor: "#a7f3d0" };
  }
  return { ...base, background: "#f3f4f6", color: "#374151", borderColor: "#d1d5db" };
}


function nextStepRowLabel(x) {
  const stav = String(x?.stav || "").trim();
  const stavPredplatneho = String(x?.stavPredplatneho || "").trim();
  const financniStav = String(x?.financniStav || "").trim();

  if (stavPredplatneho === "ceka_na_realizaci") return "Zaevidovat platbu obnovy";
  if (stavPredplatneho === "ceka_na_obnovu") return "Připravit obnovu";
  if (financniStav === "zaplaceno" && stav !== "vyfakturovano") return "Vyfakturovat";
  if (stav === "dokonceno" && financniStav !== "zaplaceno") return "Zaevidovat platbu";
  return "";
}

function renewalBadgeStyle(status) {
  const base = {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    border: "1px solid transparent",
    whiteSpace: "nowrap",
  };

  if (status === "potvrzena") {
    return { ...base, background: "#ecfdf5", color: "#065f46", borderColor: "#a7f3d0" };
  }
  if (status === "pripravena") {
    return { ...base, background: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" };
  }
  return { ...base, background: "#f3f4f6", color: "#374151", borderColor: "#d1d5db" };
}

function renewalStatusLabel(status) {
  if (status === "potvrzena") return "Potvrzena";
  if (status === "pripravena") return "Připravena";
  return "Nepřipraveno";
}

function badgeStyle(status) {
  const base = {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 700,
    border: "1px solid transparent",
    whiteSpace: "nowrap",
  };

  if (status === "nova") {
    return { ...base, background: "#f3f4f6", color: "#374151", borderColor: "#d1d5db" };
  }
  if (status === "naplanovano") {
    return { ...base, background: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" };
  }
  if (status === "rozpracovano") {
    return { ...base, background: "#fff7ed", color: "#c2410c", borderColor: "#fdba74" };
  }
  if (status === "dokonceno") {
    return { ...base, background: "#ecfdf5", color: "#065f46", borderColor: "#a7f3d0" };
  }
  if (status === "vyfakturovano") {
    return { ...base, background: "#faf5ff", color: "#7e22ce", borderColor: "#d8b4fe" };
  }
  if (status === "zruseno") {
    return { ...base, background: "#fef2f2", color: "#991b1b", borderColor: "#fecaca" };
  }
  if (status === "zdarma") {
    return { ...base, background: "#f0fdf4", color: "#166534", borderColor: "#bbf7d0" };
  }
  if (status === "interni_test") {
    return { ...base, background: "#f5f3ff", color: "#5b21b6", borderColor: "#ddd6fe" };
  }
  return { ...base, background: "#f3f4f6", color: "#374151", borderColor: "#d1d5db" };
}

function isExactDateMatch(x, exactDateFilter) {
  const selected = String(exactDateFilter || "").trim();
  if (!selected) return false;
  const rowDate = String(x?.planovaneDatum || x?.dalsiNavsteva || "").trim();
  return !!rowDate && rowDate === selected;
}

function isPoTerminuZakazka(x, today) {
  const termin = String(x?.planovaneDatum || x?.dalsiNavsteva || "").trim();
  if (!termin) return false;
  const stav = String(x?.stav || "");
  return (
    termin < today &&
    stav !== "dokonceno" &&
    stav !== "zruseno" &&
    stav !== "vyfakturovano"
  );
}

function statusLabel(status) {
  if (status === "nova") return "Nová";
  if (status === "naplanovano") return "Naplánováno";
  if (status === "rozpracovano") return "Rozpracováno";
  if (status === "dokonceno") return "Dokončeno";
  if (status === "vyfakturovano") return "Vyfakturováno";
  if (status === "zruseno") return "Zrušeno";
  if (status === "zdarma") return "Zdarma";
  if (status === "interni_test") return "Interní test";
  return "-";
}


function formatDateList(value) {
  const raw = String(value || "").trim();
  if (!raw) return "-";
  const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return raw;
  return `${m[3]}. ${m[2]}. ${m[1]}`;
}

export default function UdrzbaZakazky({ calendarJumpToken = 0 }) {
  const today = new Date().toISOString().slice(0, 10);
  const [items, setItems] = useState([]);
  const rowRefs = useRef({});
  const [detail, setDetail] = useState(null);
  const [lastCreatedId, setLastCreatedId] = useState(() => {
    try {
      return sessionStorage.getItem(LAST_CREATED_KEY) || "";
    } catch {
      return "";
    }
  });

  const initialUiState = readStoredUiState();

  const [query, setQuery] = useState(initialUiState.query);
  const [stavFilter, setStavFilter] = useState(initialUiState.stavFilter);
  const [platbaFilter, setPlatbaFilter] = useState(initialUiState.platbaFilter);
  const [predplatneFilter, setPredplatneFilter] = useState(initialUiState.predplatneFilter);
  const [typPeceFilter, setTypPeceFilter] = useState(initialUiState.typPeceFilter);
  const [hrbitovFilter, setHrbitovFilter] = useState(initialUiState.hrbitovFilter);
  const [sortBy, setSortBy] = useState(initialUiState.sortBy);
  const [sortDir, setSortDir] = useState(initialUiState.sortDir);
  const [quickFilter, setQuickFilter] = useState(initialUiState.quickFilter);
  const [exactDateFilter, setExactDateFilter] = useState("");

  const toggleStavFilter = (value) => {
    setStavFilter((prev) => {
      const next = prev === value ? "vse" : value;
      setQuickFilter("vse");
      return next;
    });
  };

  const toggleQuickFilter = (value) => {
    setQuickFilter((prev) => {
      const next = prev === value ? "vse" : value;
      setStavFilter("vse");
      return next;
    });
  };

  const handleSortClick = (key) => {
    if (sortBy === key) {
      setSortDir((prev) => (prev === "asc" ? "desc" : "asc"));
      return;
    }
    setSortBy(key);
    setSortDir(key === "dalsi_navsteva" ? "asc" : "asc");
  };

  const renderSortArrow = (key) => {
    if (sortBy !== key) return "↕";
    return sortDir === "asc" ? "↑" : "↓";
  };

  const resetAllFiltersAndSort = () => {
    setQuery("");
    setStavFilter("vse");
    setQuickFilter("vse");
    setPlatbaFilter("vse");
    setPredplatneFilter("vse");
    setTypPeceFilter("vse");
    setHrbitovFilter("vse");
    setSortBy("dalsi_navsteva");
    setSortDir("asc");
    if (typeof window !== "undefined") {
      try {
        window.localStorage.removeItem(LS_KEY);
      } catch {}
    }
  };

  const buildExportRows = () => {
      return filteredItems.map((x) => ({
        ID: x.id || "",
        Objednavatel: x.objednavatel || "",
        Telefon: x.telefon || "",
        Email: x.email || "",
        "Hřbitov": x.hrbitov || "",
        "Číslo hrobu": x.cisloHrobu || "",
        "Lokace hrobu": x.lokaceHrobu || [x.oddeleni, x.skupina, x.cisloHrobu].filter(Boolean).join(" / "),
        "Identifikace hrobu": x.identifikaceText || [
          x.majitelHrobuJmeno ? `Majitel: ${x.majitelHrobuJmeno}` : "",
          (x.zesnulyPrijmeni || x.zesnulyDatumUmrti)
            ? `Zesnulý: ${[x.zesnulyPrijmeni, x.zesnulyDatumUmrti].filter(Boolean).join(" / ")}`
            : "",
          x.jmenoNaDesce ? `Deska: ${x.jmenoNaDesce}` : "",
        ].filter(Boolean).join(" | "),
        "Typ péče": typPeceLabel(x.typPece || x.typ || ""),
        Periodicita: periodicitaLabel(x.periodicita || ""),
        "Další návštěva": x.dalsiNavsteva || "",
        "Plánované datum": x.planovaneDatum || "",
        Stav: statusLabel(x.stav || ""),
        "Stav předplatného": subscriptionStatusLabel(x.stavPredplatneho || ""),
        "Stav obnovy": renewalStatusLabel(x.stavObnovy || ""),
        "Cena celkem": Number(x.cenaCelkem ?? x.cena ?? 0),
        "Uhrazeno celkem": Number(x.uhrazenoCelkem ?? 0),
        Doplatek: Number(x.doplatekCastka ?? 0),
        "Finanční stav": String(x.financniStav || ""),
        Poznámka: x.poznamka || x.zadaniPrace || "",
      }));
    };

    const exportFilteredToCsv = () => {
      try {
        const headers = [
          "ID",
          "Objednavatel",
          "Telefon",
          "Email",
          "Hřbitov",
          "Číslo hrobu",
          "Lokace hrobu",
          "Identifikace hrobu",
          "Typ péče",
          "Periodicita",
          "Další návštěva",
          "Plánované datum",
          "Stav",
          "Stav předplatného",
          "Stav obnovy",
          "Cena celkem",
          "Uhrazeno celkem",
          "Doplatek",
          "Finanční stav",
          "Poznámka",
        ];

        const rows = buildExportRows().map((row) => [
          row.ID,
          row.Objednavatel,
          row.Telefon,
          row.Email,
          row["Hřbitov"],
          row["Číslo hrobu"],
          row["Lokace hrobu"],
          row["Identifikace hrobu"],
          row["Typ péče"],
          row.Periodicita,
          row["Další návštěva"],
          row["Plánované datum"],
          row.Stav,
          row["Stav předplatného"],
          row["Stav obnovy"],
          row["Cena celkem"],
          row["Uhrazeno celkem"],
          row.Doplatek,
          row["Finanční stav"],
          row.Poznámka,
        ]);

        const csv = [
          headers.map(csvEscape).join(";"),
          ...rows.map((row) => row.map(csvEscape).join(";")),
        ].join("\n");

        const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
        a.href = url;
        a.download = `udrzba-zakazky-${stamp}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        alert(e?.message || "Export CSV selhal");
      }
    };

    const exportFilteredToXlsx = () => {
    try {
      const rows = buildExportRows();
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Zakazky");

      const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
      XLSX.writeFile(wb, `udrzba-zakazky-${stamp}.xlsx`);
    } catch (e) {
      alert(e?.message || "Export XLSX selhal");
    }
  };

  const printFilteredView = () => {
    try {
      const rows = buildExportRows();
      const stamp = new Date().toLocaleString("cs-CZ");

      const tableRows = rows.map((row) => `
        <tr
                        ref={(el) => {
                          if (el && x?.id) rowRefs.current[x.id] = el;
                        }}
                        style={{
                          background: String(x?.id || "") === String(lastCreatedId || "") ? "#fef9c3" : undefined,
                          transition: "background 0.6s"
                        }}>
          <td>${String(row.ID || "")}</td>
          <td>${String(row.Objednavatel || "")}</td>
          <td>${String(row["Hřbitov"] || "")}</td>
          <td>${String(row["Číslo hrobu"] || "")}</td>
          <td>${String(row["Typ péče"] || "")}</td>
          <td>${String(row["Další návštěva"] || "")}</td>
          <td>${String(row.Stav || "")}</td>
          <td>${String(row["Stav předplatného"] || "")}</td>
          <td>${String(row["Cena celkem"] || "")}</td>
          <td>${String(row["Uhrazeno celkem"] || "")}</td>
          <td>${String(row.Doplatek || "")}</td>
          <td>${String(row["Finanční stav"] || "")}</td>
        </tr>
      `).join("");

      const win = window.open("", "_blank", "width=1400,height=900");
      if (!win) {
        throw new Error("Nepodařilo se otevřít tiskové okno.");
      }

      win.document.write(`
        <!doctype html>
        <html lang="cs">
        <head>
          <meta charset="utf-8" />
          <title>Přehled zakázek údržby</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 24px; color: #111827; }
            h1 { margin: 0 0 8px; font-size: 24px; }
            .meta { margin-bottom: 16px; color: #4b5563; font-size: 13px; }
            table { width: 100%; border-collapse: collapse; font-size: 12px; }
            th, td { border: 1px solid #d1d5db; padding: 6px 8px; text-align: left; vertical-align: top; }
            th { background: #f3f4f6; }
            @media print {
              body { padding: 0; }
              .no-print { display: none; }
            }
          </style>
        </head>
        <body>
          <div class="no-print" style="margin-bottom:16px;">
            <button onclick="window.print()">Tisk / Uložit do PDF</button>
          </div>
          <h1>Přehled zakázek údržby</h1>
          <div class="meta">Vygenerováno: ${stamp} • Počet záznamů: ${rows.length}</div>
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Objednavatel</th>
                <th>Hřbitov</th>
                <th>Číslo hrobu</th>
                <th>Typ péče</th>
                <th>Další návštěva</th>
                <th>Stav</th>
                <th>Stav předplatného</th>
                <th>Cena celkem</th>
                <th>Uhrazeno celkem</th>
                <th>Doplatek</th>
                <th>Finanční stav</th>
              </tr>
            </thead>
            <tbody>${tableRows}</tbody>
          </table>
        </body>
        </html>
      `);
      win.document.close();
      win.focus();
    } catch (e) {
      alert(e?.message || "Tiskový přehled selhal");
    }
  };

  const sortableThStyle = {
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
  };

  const stickyThStyle = {
    position: "sticky",
    top: 0,
    zIndex: 5,
    background: "#f8fafc",
    boxShadow: "0 1px 0 #e5e7eb",
  };

  const activeSortThStyle = (key) => ({
    background: sortBy === key ? "#eef6ff" : stickyThStyle.background,
    color: sortBy === key ? "#0f3d91" : "inherit",
  });

  const stickyFirstColStyle = {
    position: "sticky",
    left: 0,
    zIndex: 4,
    background: "#ffffff",
    boxShadow: "1px 0 0 #e5e7eb",
  };

  const stickyFirstHeaderStyle = {
    ...stickyThStyle,
    left: 0,
    zIndex: 7,
    background: "#f8fafc",
    boxShadow: "1px 0 0 #e5e7eb, 0 1px 0 #e5e7eb",
  };

  const stickySecondColStyle = {
    position: "sticky",
    left: 90,
    zIndex: 3,
    background: "#ffffff",
    boxShadow: "1px 0 0 #e5e7eb",
  };

  const stickySecondHeaderStyle = (key) => ({
    ...stickyThStyle,
    ...activeSortThStyle(key),
    left: 90,
    zIndex: 6,
    background: sortBy === key ? "#eef6ff" : "#f8fafc",
    boxShadow: "1px 0 0 #e5e7eb, 0 1px 0 #e5e7eb",
  });

  const stickyActionColStyle = {
    position: "sticky",
    right: 0,
    zIndex: 3,
    background: "#ffffff",
    boxShadow: "-1px 0 0 #e5e7eb",
  };

  const stickyActionHeaderStyle = {
    ...stickyThStyle,
    right: 0,
    zIndex: 6,
    background: "#f8fafc",
    boxShadow: "-1px 0 0 #e5e7eb, 0 1px 0 #e5e7eb",
  };

  const statusRowTint = (stav) => {
    const s = String(stav || "");
    if (s === "nova") return "#fffdf5";
    if (s === "rozpracovano") return "#f5faff";
    if (s === "dokonceno") return "#f7fcf7";
    if (s === "vyfakturovano") return "#f7f7fb";
    return "";
  };

  const rowBaseStyle = (index, isOverdue, stav, isExactDate = false) => ({
    background: isExactDate
      ? "#eff6ff"
      : isOverdue
      ? "#fff7f7"
      : statusRowTint(stav) || (index % 2 === 0 ? "#ffffff" : "#fbfcfe"),
    transition: "background 120ms ease",
    boxShadow: isExactDate ? "inset 0 0 0 1px #bfdbfe" : "none",
    borderLeft: isExactDate ? "4px solid #2563eb" : "",
  });

  const rowHoverStyle = (isOverdue, stav) => ({
    background: isOverdue ? "#ffecec" : statusRowTint(stav) || "#f5f9ff",
  }); 

  const activeFilterLabel =
    stavFilter !== "vse"
      ? ({
          nova: "Nová",
          naplanovano: "Naplánováno",
          rozpracovano: "Rozpracováno",
          dokonceno: "Dokončeno",
          vyfakturovano: "Vyfakturováno",
        }[stavFilter] || stavFilter)      : exactDateFilter
      ? `Přesné datum: ${formatDateList(exactDateFilter)}`
      : quickFilter !== "vse"
        ? ({
          dnes: "Dnes",
          tento_tyden: "Tento týden",
          hotovo: "Hotovo",
          vyfakturovano: "Vyfakturováno",
          ceka_na_fakturaci: "Čeká na fakturaci",
          po_terminu: "Po termínu",
          opakovane: "Opakované",
          konci_brzy: "Končí brzy",
          ceka_na_obnovu: "Čeká na obnovu",
          obnova_pripravena: "Obnova připravena",
          obnova_potvrzena: "Obnova potvrzena",
          vyprselo: "Vypršelo",
        }[quickFilter] || quickFilter)
      : "";

  const activateDashboardFilter = (kind) => {
    if (kind === "all") {
      setQuickFilter("vse");
      setExactDateFilter("");
      setStavFilter("vse");
      setPlatbaFilter("vse");
      return;
    }

    if (kind === "paid") {
      setQuickFilter("vse");
      setStavFilter("vse");
      setPlatbaFilter("zaplaceno");
      return;
    }

    if (kind === "unpaid") {
      setQuickFilter("vse");
      setStavFilter("vse");
      setPlatbaFilter("nezaplaceno");
      return;
    }

    if (kind === "overdue") {
      setPlatbaFilter("vse");
      setStavFilter("vse");
      setQuickFilter("po_terminu");
      return;
    }

    if (kind === "renewal_waiting") {
      setPlatbaFilter("vse");
      setStavFilter("vse");
      setQuickFilter("ceka_na_obnovu");
      return;
    }

    if (kind === "done_unpaid") {
      setPlatbaFilter("vse");
      setStavFilter("vse");
      setQuickFilter("hotovo_nezaplaceno");
      return;
    }

    if (kind === "paid_not_invoiced") {
      setPlatbaFilter("vse");
      setStavFilter("vse");
      setQuickFilter("zaplaceno_nevyfakturovano");
      return;
    }
  };

  const load = async () => {
    try {
      const d = await apiJson(`${API}/zakazky`, { method: "GET" });
      setItems(Array.isArray(d?.items) ? d.items : []);
    } catch {
      setItems([]);
    }
  };

  useEffect(() => {
    try {
      const jumpFilter = sessionStorage.getItem("udrzba_calendar_jump_filter");
      if (!jumpFilter) return;

      setQuery("");
      setStavFilter("vse");
      setPlatbaFilter("vse");
      setPredplatneFilter("vse");
      setTypPeceFilter("vse");
      setHrbitovFilter("vse");
      setSortBy("dalsi_navsteva");
      setSortDir("asc");
      setQuickFilter(String(jumpFilter || "vse"));
      sessionStorage.removeItem("udrzba_calendar_jump_filter");
    } catch {}
  }, [calendarJumpToken]);

  useEffect(() => {
    if (!calendarJumpToken) return;
    try {
      const jumpDate = sessionStorage.getItem("udrzba_calendar_jump_date");
      if (!jumpDate) return;

      setQuery("");
      setStavFilter("vse");
      setPlatbaFilter("vse");
      setPredplatneFilter("vse");
      setTypPeceFilter("vse");
      setHrbitovFilter("vse");
      setQuickFilter("vse");
      setExactDateFilter(String(jumpDate || "").slice(0, 10));
      setSortBy("dalsi_navsteva");
      setSortDir("asc");

      sessionStorage.removeItem("udrzba_calendar_jump_date");
    } catch {}
  }, [calendarJumpToken]);


  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (!lastCreatedId) return;

    const exists = Array.isArray(items) && items.some((x) => String(x?.id || "") === String(lastCreatedId || ""));
    if (exists && !detail) {
      openDetail(lastCreatedId);
    }

    const t = setTimeout(() => {
      setLastCreatedId("");
      try {
        sessionStorage.removeItem(LAST_CREATED_KEY);
      } catch {}
    }, 12000);
    return () => clearTimeout(t);
  }, [lastCreatedId, items, detail]);

  useEffect(() => {
    if (!lastCreatedId) return;
    const el = rowRefs.current[lastCreatedId];
    if (!el || typeof el.scrollIntoView !== "function") return;
    const t = setTimeout(() => {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 200);
    return () => clearTimeout(t);
  }, [lastCreatedId, items]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      window.localStorage.setItem(
        LS_KEY,
        JSON.stringify({
          query,
          stavFilter,
          platbaFilter,
          predplatneFilter,
          typPeceFilter,
          hrbitovFilter,
          sortBy,
          sortDir,
          quickFilter,
        })
      );
    } catch {}
  }, [query, stavFilter, platbaFilter, predplatneFilter, typPeceFilter, hrbitovFilter, sortBy, sortDir, quickFilter]);

  const filteredItems = useMemo(() => {
    let out = [...items];
    const q = String(query || "").trim().toLowerCase();

    if (q) {
      out = out.filter((x) => {
        const hay = [
          x.id,
          x.objednavatel,
          x.telefon,
          x.email,
          x.cisloHrobu,
          x.hrbitov,
          x.zadaniPrace,
          x.poznamka,
          x.typPece,
          x.periodicita,
          x.stavPredplatneho,
        ]
          .map((v) => String(v || "").toLowerCase())
          .join(" ");
        return hay.includes(q);
      });
    }

    if (stavFilter !== "vse") {
      out = out.filter((x) => String(x.stav || "") === stavFilter);
    }

    if (platbaFilter === "zaplaceno") {
      out = out.filter((x) => String(x.financniStav || "") === "zaplaceno");
    } else if (platbaFilter === "nezaplaceno") {
      out = out.filter((x) => String(x.financniStav || "") !== "zaplaceno");
    }

      if (predplatneFilter !== "vse") {
        out = out.filter((x) => String(x.stavPredplatneho || "") === predplatneFilter);
      }

      if (typPeceFilter !== "vse") {
        out = out.filter((x) => String(x.typPece || "") === typPeceFilter);
      }

      if (hrbitovFilter !== "vse") {
        out = out.filter((x) => String(x.hrbitov || "") === hrbitovFilter);
      }

      if (exactDateFilter) {
      out = out.filter((x) => String(x.planovaneDatum || x.dalsiNavsteva || "").trim() === exactDateFilter);
    }

    if (quickFilter === "dnes") {
        out = out.filter((x) => String(x.planovaneDatum || x.dalsiNavsteva || "") === today);
      } else if (quickFilter === "tento_tyden") {
        const now = new Date();
        const day = now.getDay();
        const mondayOffset = day === 0 ? -6 : 1 - day;
        const monday = new Date(now);
        monday.setDate(now.getDate() + mondayOffset);
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        const from = monday.toISOString().slice(0, 10);
        const to = sunday.toISOString().slice(0, 10);

        out = out.filter((x) => {
          const d = String(x.planovaneDatum || x.dalsiNavsteva || "").trim();
          return d && d >= from && d <= to;
        });
      } else if (quickFilter === "hotovo") {
        out = out.filter((x) => String(x.stav || "") === "dokonceno");
      } else if (quickFilter === "vyfakturovano") {
        out = out.filter((x) => String(x.stav || "") === "vyfakturovano");
        } else if (quickFilter === "hotovo_nezaplaceno") {
          out = out.filter((x) => String(x.stav || "") === "dokonceno" && String(x.financniStav || "") !== "zaplaceno");
        } else if (quickFilter === "zaplaceno_nevyfakturovano") {
          out = out.filter((x) => String(x.financniStav || "") === "zaplaceno" && String(x.stav || "") !== "vyfakturovano");
      } else if (quickFilter === "po_terminu") {
        out = out.filter((x) => {
          const d = String(x.planovaneDatum || x.dalsiNavsteva || "").trim();
          return d && d < today && String(x.stav || "") !== "dokonceno" && String(x.stav || "") !== "zruseno";
        });
        } else if (quickFilter === "opakovane") {
          out = out.filter((x) => !!x.opakovana);
        } else if (quickFilter === "konci_brzy") {
          out = out.filter((x) => String(x.stavPredplatneho || "") === "konci_brzy");
        } else if (quickFilter === "ceka_na_obnovu") {
          out = out.filter((x) => String(x.stavPredplatneho || "") === "ceka_na_obnovu");
        } else if (quickFilter === "obnova_pripravena") {
          out = out.filter((x) => !!x.obnovaPripravena && String(x.stavObnovy || "") !== "potvrzena");
        } else if (quickFilter === "obnova_potvrzena") {
          out = out.filter((x) => String(x.stavObnovy || "") === "potvrzena");
        }
      if (sortBy === "objednavatel") {
        out.sort((a, b) => {
          const av = String(a.objednavatel || "").toLocaleLowerCase("cs");
          const bv = String(b.objednavatel || "").toLocaleLowerCase("cs");
          return sortDir === "asc" ? av.localeCompare(bv, "cs") : bv.localeCompare(av, "cs");
        });
      }

      if (sortBy === "stav") {
        out.sort((a, b) => {
          const av = String(a.stav || "").toLocaleLowerCase("cs");
          const bv = String(b.stav || "").toLocaleLowerCase("cs");
          return sortDir === "asc" ? av.localeCompare(bv, "cs") : bv.localeCompare(av, "cs");
        });
      }

      if (sortBy === "cena") {
        out.sort((a, b) => {
          const av = Number(a.cenaCelkem ?? a.cena ?? 0);
          const bv = Number(b.cenaCelkem ?? b.cena ?? 0);
          return sortDir === "asc" ? av - bv : bv - av;
        });
      }

      if (sortBy === "dalsi_navsteva") {
        out.sort((a, b) => {
          const ad = String(a.planovaneDatum || a.dalsiNavsteva || "");
          const bd = String(b.planovaneDatum || b.dalsiNavsteva || "");
          const at = ad ? new Date(ad).getTime() : 0;
          const bt = bd ? new Date(bd).getTime() : 0;
          return sortDir === "asc" ? at - bt : bt - at;
        });
      }

    return out;
  }, [items, query, stavFilter, platbaFilter, predplatneFilter, typPeceFilter, hrbitovFilter, quickFilter, exactDateFilter, sortBy, sortDir]);

  const listSummaryLabel = `${filteredItems.length} z ${items.length} zakázek`;

  const stats = useMemo(() => {
    return {
      total: filteredItems.length,
      suma: filteredItems.reduce((sum, x) => sum + Number(x.cenaCelkem ?? x.cena ?? 0), 0),
      nova: filteredItems.filter((x) => String(x.stav || "") === "nova").length,
      naplanovano: filteredItems.filter((x) => String(x.stav || "") === "naplanovano").length,
      rozpracovano: filteredItems.filter((x) => String(x.stav || "") === "rozpracovano").length,
      dokonceno: filteredItems.filter((x) => String(x.stav || "") === "dokonceno").length,
      vyfakturovano: filteredItems.filter((x) => String(x.stav || "") === "vyfakturovano").length,
      poTerminu: filteredItems.filter((x) => isPoTerminuZakazka(x, today)).length,
      konciBrzy: filteredItems.filter((x) => x.stavPredplatneho === "konci_brzy").length,
      cekaNaObnovu: filteredItems.filter((x) => x.stavPredplatneho === "ceka_na_obnovu").length,
      vyprselo: filteredItems.filter((x) => x.stavPredplatneho === "vyprselo").length,
    };
  }, [filteredItems]);

  const summaryStats = useMemo(() => {
    const totalCount = filteredItems.length;
    const totalAmount = filteredItems.reduce((sum, x) => sum + Number(x.cenaCelkem ?? x.cena ?? 0), 0);
    const paidAmount = filteredItems.reduce(
      (sum, x) => sum + Number(x.uhrazenoCelkem ?? 0),
      0
    );
    const unpaidAmount = filteredItems.reduce(
      (sum, x) => sum + Number(x.doplatekCastka ?? Math.max(0, Number(x.cenaCelkem ?? x.cena ?? 0) - Number(x.uhrazenoCelkem ?? 0))),
      0
    );
    const overdueCount = filteredItems.filter((x) => isPoTerminuZakazka(x, today)).length;
    const renewalWaitingCount = filteredItems.filter((x) => String(x.stavPredplatneho || "") === "ceka_na_obnovu").length;

    const renewalPreparedCount = filteredItems.filter((x) => !!x.obnovaPripravena && String(x.stavObnovy || "") !== "potvrzena").length;
    const renewalConfirmedCount = filteredItems.filter((x) => String(x.stavObnovy || "") === "potvrzena").length;
    const novaCount = filteredItems.filter((x) => String(x.stav || "") === "nova").length;
    const rozpracovanoCount = filteredItems.filter((x) => String(x.stav || "") === "rozpracovano").length;
    const dokoncenoCount = filteredItems.filter((x) => String(x.stav || "") === "dokonceno").length;
    const vyfakturovanoCount = filteredItems.filter((x) => String(x.stav || "") === "vyfakturovano").length;
      const hotovoNezaplacenoCount = filteredItems.filter((x) => String(x.stav || "") === "dokonceno" && String(x.financniStav || "") !== "zaplaceno").length;
      const zaplacenoNevyfakturovanoCount = filteredItems.filter((x) => String(x.financniStav || "") === "zaplaceno" && String(x.stav || "") !== "vyfakturovano").length;

    const paidPercent = totalAmount > 0 ? Math.round((paidAmount / totalAmount) * 100) : 0;

    return {
      totalCount,
      totalAmount,
      paidAmount,
      unpaidAmount,
      overdueCount,
      renewalWaitingCount,
      novaCount,
      rozpracovanoCount,
      dokoncenoCount,
      vyfakturovanoCount,
        hotovoNezaplacenoCount,
        zaplacenoNevyfakturovanoCount,
      paidPercent,
    };
  }, [filteredItems, today]);

  const markDone = async (id) => {
      try {
        const d = await apiJson(`${API}/zakazky/${id}/dokonceno`, {
          method: "POST",
          body: {},
        });

        if (!d?.ok) {
          alert(d?.error || "Označení zakázky jako dokončené selhalo");
          return;
        }

        if (d?.item) {
          setItems((prev) => prev.map((x) => (String(x.id) === String(id) ? d.item : x)));

          const needsRenewal =
            String(d?.item?.stavPredplatneho || "").trim() === "ceka_na_obnovu" ||
            !!d?.item?.obnovaPripravena;

          if (needsRenewal) {
            setDetail(d.item);
            alert("Zakázka byla dokončena a péče nyní čeká na obnovu. V detailu můžeš rovnou připravit nebo odeslat e-mail a potvrdit obnovu.");
          }
        }

        await load();
      } catch (e) {
        alert(e?.message || "Označení zakázky jako dokončené selhalo");
      }
    };

  const markPaid = async (id) => {
    try {
      const d = await apiJson(`${API}/zakazky/${id}/zaplaceno`, {
        method: "POST",
        body: {},
      });

      if (!d?.ok) {
        throw new Error(d?.error || "Uložení platby selhalo");
      }

      if (d?.item) {
        setItems((prev) => prev.map((x) => (String(x.id) === String(id) ? d.item : x)));
        if (detail && String(detail.id) === String(id)) setDetail(d.item);
      }

      await load();
    } catch (e) {
      alert(e?.message || "Označení jako zaplaceno selhalo");
    }
  };

  const openDetail = async (id) => {
    try {
      const d = await apiJson(`${API}/zakazky/${id}`, { method: "GET" });
      if (d?.ok && d?.item) setDetail(d.item);
    } catch (e) {
      alert(e?.message || "Nepodařilo se otevřít detail zakázky.");
    }
  };

  const prepareRenewal = async (id) => {
    try {
      const d = await apiJson(`${API}/zakazky/${id}`, { method: "GET" });
      if (d?.ok && d?.item) {
        setDetail(d.item);
        return;
      }

      alert("Nepodařilo se otevřít detail zakázky.");
    } catch (e) {
      alert(e?.message || "Nepodařilo se otevřít detail zakázky.");
    }
  };

  const markInvoiced = async (id) => {
    try {
      const d = await apiJson(`${API}/zakazky/${id}/vyfakturovano`, {
        method: "POST",
        body: {},
      });
      if (d?.ok && d?.item) {
        setItems((prev) => prev.map((it) => (String(it.id) === String(id) ? d.item : it)));
        if (detail && String(detail.id) === String(id)) setDetail(d.item);
      }
    } catch (err) {
      console.error("markInvoiced error:", err);
      alert("Nepodařilo se označit zakázku jako vyfakturovanou.");
    }
  };

  const handleDetailSaved = (savedItem) => {
    if (!savedItem?.id) return;
    setDetail(savedItem);
    setItems((prev) => prev.map((x) => (String(x.id) === String(savedItem.id) ? savedItem : x)));
  };

  const markRenewalConfirmed = async (id) => {
    try {
      const d = await apiJson(`${API}/zakazky/${id}`, { method: "GET" });
      if (!(d?.ok && d?.item)) return;

      const saveData = await apiJson(`${API}/zakazky/${id}`, {
        method: "PUT",
        body: {
          ...d.item,
          stavObnovy: "potvrzena",
          datumPotvrzeniObnovy: new Date().toISOString(),
          stavPredplatneho: "aktivni",
        },
      });

      if (saveData?.ok && saveData?.item) {
        setItems((prev) => prev.map((x) => (String(x.id) === String(id) ? saveData.item : x)));
        if (detail && String(detail.id) === String(id)) setDetail(saveData.item);
      }
    } catch (e) {
      alert(e?.message || "Potvrzení obnovy selhalo");
    }
  };

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>Zakázky</h2>

      <div
        style={{
          display: "grid",
            gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr 1fr 1fr",
          gap: 10,
          marginBottom: 14,
        }}
      >
        <input
          style={inputStyle}
          placeholder="Hledat podle jména, hrobu, telefonu, poznámky…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />

        <select style={inputStyle} value={stavFilter} onChange={(e) => setStavFilter(e.target.value)}>
          <option value="vse">Všechny stavy</option>
          <option value="nova">Nová</option>
          <option value="naplanovano">Naplánováno</option>
          <option value="rozpracovano">Rozpracováno</option>
          <option value="dokonceno">Dokončeno</option>
          <option value="vyfakturovano">Vyfakturováno</option>
          <option value="zruseno">Zrušeno</option>
          <option value="zdarma">Zdarma</option>
          <option value="interni_test">Interní test</option>
        </select>

        <select style={inputStyle} value={typPeceFilter} onChange={(e) => setTypPeceFilter(e.target.value)}>
          <option value="vse">Všechny typy péče</option>
          <option value="jednorazova">Jednorázová</option>
          <option value="predplatne">Předplatné</option>
          <option value="balicek">Balíček</option>
        </select>

        <select style={inputStyle} value={hrbitovFilter} onChange={(e) => setHrbitovFilter(e.target.value)}>
          <option value="vse">Všechny hřbitovy</option>
          <option value="Český Krumlov">Český Krumlov</option>
          <option value="Křemže">Křemže</option>
          <option value="Chvalšiny">Chvalšiny</option>
          <option value="Hořice na Šumavě">Hořice na Šumavě</option>
          <option value="Zlatá Koruna">Zlatá Koruna</option>
        </select>

        <select style={inputStyle} value={platbaFilter} onChange={(e) => setPlatbaFilter(e.target.value)}>
          <option value="vse">Všechny platby</option>
          <option value="zaplaceno">Zaplaceno</option>
          <option value="nezaplaceno">Nezaplaceno</option>
        </select>

        <select style={inputStyle} value={predplatneFilter} onChange={(e) => setPredplatneFilter(e.target.value)}>
          <option value="vse">Všechna předplatná</option>
          <option value="aktivni">Aktivní</option>
          <option value="konci_brzy">Končí brzy</option>
          <option value="ceka_na_obnovu">Čeká na obnovu</option>
          <option value="vyprselo">Vypršelo</option>
        </select>

        <select
          style={inputStyle}
          value={`${sortBy}:${sortDir}`}
          onChange={(e) => {
            const [nextSortBy, nextSortDir] = String(e.target.value || "dalsi_navsteva:asc").split(":");
            setSortBy(nextSortBy || "dalsi_navsteva");
            setSortDir(nextSortDir || "asc");
          }}
        >
          <option value="dalsi_navsteva:asc">Další návštěva ↑</option>
          <option value="dalsi_navsteva:desc">Další návštěva ↓</option>
          <option value="objednavatel:asc">Objednavatel A–Z</option>
          <option value="objednavatel:desc">Objednavatel Z–A</option>
          <option value="stav:asc">Stav A–Z</option>
          <option value="stav:desc">Stav Z–A</option>
          <option value="cena:asc">Cena od nejnižší</option>
          <option value="cena:desc">Cena od nejvyšší</option>
        </select>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
        <button
          onClick={resetAllFiltersAndSort}
          style={{
            padding: "10px 14px",
            borderRadius: 10,
            border: "1px solid #d1d5db",
            background: "#ffffff",
            cursor: "pointer",
            fontWeight: 700,
          }}
          title="Vrátí výchozí filtry, řazení a smaže uložený pohled"
        >
          Obnovit výchozí pohled
        </button>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
          marginBottom: 14,
          padding: "10px 12px",
          border: "1px solid #e5e7eb",
          borderRadius: 10,
          background: "#ffffff",
          flexWrap: "wrap",
        }}
      >
        <div style={{ fontSize: 12, color: "#6b7280", fontWeight: 700 }}>
          Export aktuálně zobrazeného výběru
        </div>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button
            onClick={exportFilteredToCsv}
            style={{
              padding: "10px 14px",
              borderRadius: 10,
              border: "1px solid #2563eb",
              background: "#eff6ff",
              color: "#1d4ed8",
              cursor: "pointer",
              fontWeight: 700,
            }}
            title="Exportuje právě zobrazené zakázky do CSV"
          >
            Export CSV
          </button>

          <button
            onClick={exportFilteredToXlsx}
            style={{
              padding: "10px 14px",
              borderRadius: 10,
              border: "1px solid #0f766e",
              background: "#ecfdf5",
              color: "#0f766e",
              cursor: "pointer",
              fontWeight: 700,
            }}
            title="Exportuje právě zobrazené zakázky do XLSX"
          >
            Export XLSX
          </button>

          <button
            onClick={printFilteredView}
            style={{
              padding: "10px 14px",
              borderRadius: 10,
              border: "1px solid #7c3aed",
              background: "#f5f3ff",
              color: "#6d28d9",
              cursor: "pointer",
              fontWeight: 700,
            }}
            title="Otevře tiskový přehled pro tisk nebo uložení do PDF"
          >
            Tisk / PDF
          </button>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          gap: 8,
          flexWrap: "wrap",
          marginBottom: 14,
          padding: "10px 12px",
          border: "1px solid #e5e7eb",
          borderRadius: 10,
          background: "#ffffff",
        }}
      >
        <button type="button" style={quickBtnStyle(quickFilter === "vse")} onClick={() => toggleQuickFilter("vse")}>Vše</button>
        <button type="button" style={quickBtnStyle(quickFilter === "dnes")} onClick={() => toggleQuickFilter("dnes")}>Dnes</button>
        <button type="button" style={quickBtnStyle(quickFilter === "tento_tyden")} onClick={() => toggleQuickFilter("tento_tyden")}>Tento týden</button>
        <button type="button" style={quickBtnStyle(quickFilter === "po_terminu")} onClick={() => toggleQuickFilter("po_terminu")}>Po termínu</button>
        <button type="button" style={quickBtnStyle(quickFilter === "opakovane")} onClick={() => toggleQuickFilter("opakovane")}>Opakované</button>
        <button type="button" style={quickBtnStyle(quickFilter === "konci_brzy")} onClick={() => toggleQuickFilter("konci_brzy")}>Končí brzy</button>
        <button type="button" style={quickBtnStyle(quickFilter === "ceka_na_obnovu")} onClick={() => toggleQuickFilter("ceka_na_obnovu")}>Čeká na obnovu</button>
        <button type="button" style={quickBtnStyle(quickFilter === "obnova_pripravena")} onClick={() => toggleQuickFilter("obnova_pripravena")}>Obnova připravena</button>
        <button type="button" style={quickBtnStyle(quickFilter === "obnova_potvrzena")} onClick={() => toggleQuickFilter("obnova_potvrzena")}>Obnova potvrzena</button>
      </div>

      {exactDateFilter ? (
        <div style={{ marginTop: 10, marginBottom: 10, color: "#475569", fontSize: 14 }}>
          Aktivní filtr dne: <strong>{formatDateList(exactDateFilter)}</strong>{" "}
          <button
            type="button"
            onClick={() => setExactDateFilter("")}
            style={{
              marginLeft: 8,
              border: "1px solid #cbd5e1",
              background: "#fff",
              borderRadius: 999,
              padding: "4px 10px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Zrušit
          </button>
        </div>
      ) : null}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
          gap: 10,
          marginBottom: 14,
        }}
      >
        <div
          style={summaryCardStyle(quickFilter === "vse" && stavFilter === "vse" && platbaFilter === "vse", true)}
          onClick={() => activateDashboardFilter("all")}
          title="Zobrazit všechny zakázky"
        >
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Zobrazené zakázky</div>
          <div style={{ fontSize: 24, fontWeight: 800 }}>{summaryStats.totalCount}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>
            {activeFilterLabel ? `Filtr: ${activeFilterLabel}` : "Bez omezení"}
          </div>
        </div>

        <div style={summaryCardStyle()}>
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Součet cen</div>
          <div style={{ fontSize: 24, fontWeight: 800 }}>{money(summaryStats.totalAmount)}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Aktuálně zobrazený výběr</div>
        </div>

        <div
          style={summaryCardStyle(platbaFilter === "zaplaceno", true)}
          onClick={() => activateDashboardFilter("paid")}
          title="Filtrovat jen zaplacené zakázky"
        >
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Zaplaceno</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#166534" }}>{money(summaryStats.paidAmount)}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Jen uhrazené zakázky</div>
        </div>

        <div
          style={summaryCardStyle(platbaFilter === "nezaplaceno", true)}
          onClick={() => activateDashboardFilter("unpaid")}
          title="Filtrovat jen neuhrazené zakázky"
        >
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Nezaplaceno</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#b45309" }}>{money(summaryStats.unpaidAmount)}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Jen neuhrazené zakázky</div>
        </div>

        <div
          style={summaryCardStyle(quickFilter === "po_terminu", true)}
          onClick={() => activateDashboardFilter("overdue")}
          title="Filtrovat zakázky po termínu"
        >
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Po termínu</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#b91c1c" }}>{summaryStats.overdueCount}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Vyžadují pozornost</div>
        </div>

        <div
          style={summaryCardStyle(quickFilter === "ceka_na_obnovu", true)}
          onClick={() => activateDashboardFilter("renewal_waiting")}
          title="Filtrovat předplatná čekající na obnovu"
        >
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Čeká na obnovu</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#7c2d12" }}>{summaryStats.renewalWaitingCount}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Předplatná k řešení</div>
        </div>

        <div style={summaryCardStyle()}>
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Nové</div>
          <div style={{ fontSize: 24, fontWeight: 800 }}>{summaryStats.novaCount}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Stav nová</div>
        </div>

        <div style={summaryCardStyle()}>
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Rozpracováno</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#c2410c" }}>{summaryStats.rozpracovanoCount}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Aktivní práce</div>
        </div>

          <div
            style={summaryCardStyle(quickFilter === "hotovo_nezaplaceno", true)}
            onClick={() => activateDashboardFilter("done_unpaid")}
            title="Filtrovat dokončené, ale nezaplacené zakázky"
          >
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Hotovo nezaplaceno</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: "#b45309" }}>{summaryStats.hotovoNezaplacenoCount}</div>
            <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Čekají na úhradu</div>
          </div>

          <div
            style={summaryCardStyle(quickFilter === "zaplaceno_nevyfakturovano", true)}
            onClick={() => activateDashboardFilter("paid_not_invoiced")}
            title="Filtrovat zaplacené, ale nevyfakturované zakázky"
          >
            <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>K fakturaci</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: "#7e22ce" }}>{summaryStats.zaplacenoNevyfakturovanoCount}</div>
            <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Zaplacené, čekají na fakturaci</div>
          </div>

        <div style={summaryCardStyle()}>
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Dokončeno</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#166534" }}>{summaryStats.dokoncenoCount}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Hotové bez fakturace</div>
        </div>

        <div style={summaryCardStyle()}>
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Vyfakturováno</div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#7e22ce" }}>{summaryStats.vyfakturovanoCount}</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Uzavřené zakázky</div>
        </div>

        <div style={summaryCardStyle()}>
          <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>Uhrazenost</div>
          <div style={{ fontSize: 24, fontWeight: 800 }}>{summaryStats.paidPercent} %</div>
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>Podíl zaplacené částky</div>
        </div>
      </div>

        <div
          style={{
            marginBottom: 14,
            padding: 12,
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            background: "#ffffff",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(135px, 1fr))",
              gap: 8,
          }}
        >
          <div
            onClick={() => toggleStavFilter("nova")}
            style={{
              cursor: "pointer",
              padding: "8px 10px",
              minHeight: 44,
              display: "flex",
              alignItems: "center",
              borderRadius: 10,
              border: stavFilter === "nova" ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background: stavFilter === "nova" ? "#eff6ff" : "#ffffff",
            }}
            title="Zobrazit jen nové zakázky"
          >
            <strong>Nová:</strong> {stats.nova}
          </div>
          <div
            onClick={() => toggleStavFilter("naplanovano")}
            style={{
              cursor: "pointer",
              padding: "8px 10px",
              minHeight: 44,
              display: "flex",
              alignItems: "center",
              borderRadius: 10,
              border: stavFilter === "naplanovano" ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background: stavFilter === "naplanovano" ? "#eff6ff" : "#ffffff",
            }}
            title="Zobrazit jen naplánované zakázky"
          >
            <strong>Naplánováno:</strong> {stats.naplanovano}
          </div>
          <div
            onClick={() => toggleStavFilter("rozpracovano")}
            style={{
              cursor: "pointer",
              padding: "8px 10px",
              minHeight: 44,
              display: "flex",
              alignItems: "center",
              borderRadius: 10,
              border: stavFilter === "rozpracovano" ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background: stavFilter === "rozpracovano" ? "#eff6ff" : "#ffffff",
            }}
            title="Zobrazit jen rozpracované zakázky"
          >
            <strong>Rozpracováno:</strong> {stats.rozpracovano}
          </div>
          <div
            onClick={() => toggleStavFilter("dokonceno")}
            style={{
              cursor: "pointer",
              padding: "8px 10px",
              minHeight: 44,
              display: "flex",
              alignItems: "center",
              borderRadius: 10,
              border: stavFilter === "dokonceno" ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background: stavFilter === "dokonceno" ? "#eff6ff" : "#ffffff",
            }}
            title="Zobrazit jen dokončené zakázky"
          >
            <strong>Dokončeno:</strong> {stats.dokonceno}
          </div>
          <div
            onClick={() => toggleStavFilter("vyfakturovano")}
            style={{
              cursor: "pointer",
              padding: "8px 10px",
              minHeight: 44,
              display: "flex",
              alignItems: "center",
              borderRadius: 10,
              border: stavFilter === "vyfakturovano" ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background: stavFilter === "vyfakturovano" ? "#eff6ff" : "#ffffff",
            }}
            title="Zobrazit jen vyfakturované zakázky"
          >
            <strong>Vyfakturováno:</strong> {stats.vyfakturovano}
          </div>
        </div>

      <div
        style={{
          marginBottom: 14,
          padding: 12,
          border: "1px solid #e5e7eb",
          borderRadius: 10,
          background: "#ffffff",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(135px, 1fr))",
            gap: 8,
        }}
      >
        <div><strong>Počet:</strong> {stats.total}</div>
        <div><strong>Součet:</strong> {money(stats.suma)}</div>
          <div
            onClick={() => toggleQuickFilter("po_terminu")}
            style={{
              cursor: "pointer",
              padding: "8px 10px",
              minHeight: 44,
              display: "flex",
              alignItems: "center",
              borderRadius: 10,
              border: quickFilter === "po_terminu" ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background: quickFilter === "po_terminu" ? "#eff6ff" : "#ffffff",
            }}
            title="Zobrazit jen zakázky po termínu"
          >
            <strong>Po termínu:</strong> {stats.poTerminu}
          </div>
          <div
            onClick={() => toggleQuickFilter("konci_brzy")}
            style={{
              cursor: "pointer",
              padding: "8px 10px",
              minHeight: 44,
              display: "flex",
              alignItems: "center",
              borderRadius: 10,
              border: quickFilter === "konci_brzy" ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background: quickFilter === "konci_brzy" ? "#eff6ff" : "#ffffff",
            }}
            title="Zobrazit zakázky, kde předplatné končí brzy"
          >
            <strong>Končí brzy:</strong> {stats.konciBrzy}
          </div>
          <div
            onClick={() => toggleQuickFilter("ceka_na_obnovu")}
            style={{
              cursor: "pointer",
              padding: "8px 10px",
              minHeight: 44,
              display: "flex",
              alignItems: "center",
              borderRadius: 10,
              border: quickFilter === "ceka_na_obnovu" ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background: quickFilter === "ceka_na_obnovu" ? "#eff6ff" : "#ffffff",
            }}
            title="Zobrazit zakázky čekající na obnovu"
          >
            <strong>Čeká na obnovu:</strong> {stats.cekaNaObnovu}
          </div>
          <div
            onClick={() => toggleQuickFilter("vyprselo")}
            style={{
              cursor: "pointer",
              padding: "8px 10px",
              minHeight: 44,
              display: "flex",
              alignItems: "center",
              borderRadius: 10,
              border: quickFilter === "vyprselo" ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background: quickFilter === "vyprselo" ? "#eff6ff" : "#ffffff",
            }}
            title="Zobrazit zakázky s vypršelým předplatným"
          >
            <strong>Vypršelo:</strong> {stats.vyprselo}
          </div>
      </div>

            {activeFilterLabel ? (
        <div
          style={{
            marginTop: 12,
            marginBottom: 10,
            padding: "8px 10px",
            border: "1px solid #d1d5db",
            borderRadius: 10,
            background: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <div style={{ fontSize: 14 }}>
            <strong>Aktivní filtr:</strong> {activeFilterLabel}
          </div>

          <button
            type="button"
            onClick={() => {
              setStavFilter("vse");
              setQuickFilter("vse");
            }}
            style={{
              padding: "6px 10px",
              borderRadius: 8,
              border: "1px solid #cbd5e1",
              background: "#ffffff",
              cursor: "pointer",
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            × Zrušit filtr
          </button>
        </div>
      ) : null}

      <div
        style={{
          marginTop: activeFilterLabel ? 0 : 12,
          marginBottom: 10,
          fontSize: 13,
          color: "#475569",
        }}
      >
        Zobrazeno <strong>{listSummaryLabel}</strong>
        {activeFilterLabel ? <> • filtr: <strong>{activeFilterLabel}</strong></> : null}
      </div>

      <div style={{ overflowX: "auto", maxHeight: "70vh", overflowY: "auto", border: "1px solid #e5e7eb", borderRadius: 10 }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                  <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickyFirstHeaderStyle }}>ID</th>

                <th
                  style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickySecondHeaderStyle("objednavatel"), ...sortableThStyle }}
                  onClick={() => handleSortClick("objednavatel")}
                >
                  Objednavatel {renderSortArrow("objednavatel")}
                </th>

                  <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickyThStyle }}>Číslo hrobu</th>

                <th
                  style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickyThStyle, ...activeSortThStyle("dalsi_navsteva"), ...sortableThStyle }}
                  onClick={() => handleSortClick("dalsi_navsteva")}
                >
                  Další návštěva {renderSortArrow("dalsi_navsteva")}
                </th>

                  <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickyThStyle }}>Předplatné</th>

                <th
                  style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickyThStyle, ...activeSortThStyle("stav"), ...sortableThStyle }}
                  onClick={() => handleSortClick("stav")}
                >
                  Stav {renderSortArrow("stav")}
                </th>

                  <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickyThStyle }}>Vyfakturováno</th>
                  <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickyThStyle }}>Platba</th>

                <th
                  style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickyThStyle, ...activeSortThStyle("cena"), ...sortableThStyle }}
                  onClick={() => handleSortClick("cena")}
                >
                  Cena {renderSortArrow("cena")}
                </th>

                <th style={{ textAlign: "left", padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#475569", fontSize: 12, ...stickyActionHeaderStyle }}>Akce</th>
              </tr>
            </thead>

          <tbody>
              {filteredItems.map((x, index) => (
                  <tr
                    key={x.id}
                      style={{
                        ...rowBaseStyle(index, isPoTerminuZakazka(x, today), x.stav, isExactDateMatch(x, exactDateFilter)),
                        ...(String(x.id || "") === String(lastCreatedId || "")
                          ? {
                              outline: "2px solid #2563eb",
                              outlineOffset: "-2px",
                              background: "#eff6ff",
                            }
                          : {}),
                      }}
                    onMouseEnter={(e) => {
                      Object.assign(e.currentTarget.style, rowHoverStyle(isPoTerminuZakazka(x, today), x.stav));
                    }}
                    onMouseLeave={(e) => {
                      Object.assign(e.currentTarget.style, rowBaseStyle(index, isPoTerminuZakazka(x, today), x.stav, isExactDateMatch(x, exactDateFilter)));
                    }}
                  >
                      <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", ...stickyFirstColStyle }}>{x.id}</td>

                      <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", ...stickySecondColStyle }}>
                        <div>{x.objednavatel || "-"}</div>
                        <div style={{ marginTop: 4 }}>
                          <span style={typPeceBadgeStyle(x.typPece)}>{typPeceLabel(x.typPece)}</span>
                        </div>
                        <div style={{ marginTop: 6, fontSize: 12, color: "#475569", lineHeight: 1.35 }}>
                          {getMainServiceLabel(x) || "-"}
                        </div>
                      </td>

                      <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" }}>
                        <div>{x.cisloHrobu || "-"}</div>
                        <div style={{ marginTop: 4 }}>
                          <span style={hrbitovBadgeStyle(x.hrbitov)}>{x.hrbitov || "-"}</span>
                        </div>
                      </td>

                    <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", whiteSpace: "nowrap" }}>{x.planovaneDatum || x.dalsiNavsteva || "-"}</td>

                    <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", minWidth: 250 }}>
                        <div>
                          {String(x.typPece || "") === "jednorazova" ? (
                            <span style={{ fontSize: 12, color: "#6b7280" }}>—</span>
                          ) : (
                            <span style={subscriptionBadgeStyle(x.stavPredplatneho)}>{subscriptionStatusLabel(x.stavPredplatneho)}</span>
                          )}
                        </div>

                      <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>
                        {String(x.typPece || "") === "jednorazova"
                          ? "Jednorázová péče"
                          : (
                              (String(x.typPece || "") === "balicek" || String(x.typPece || "") === "balicek_4x")
                                ? `Návštěva ${Number(x.navstevaPoradi || 1)} • historie ${Array.isArray(x.navstevy) ? x.navstevy.length : 0} • zbývá ${Number(x.zbyvaNavstev || 0)} z ${Number(x.pocetNavstevCelkem || 0)}`
                                : `Návštěva ${Number(x.navstevaPoradi || 1)} • historie ${Array.isArray(x.navstevy) ? x.navstevy.length : 0} • ${x.periodicita ? `periodicita ${periodicitaLabel(x.periodicita)}` : `zbývá ${Number(x.zbyvaNavstev || 0)}`}`
                            )}
                      </div>

                        {String(x.typPece || "") !== "jednorazova" ? (
                          <div style={{ fontSize: 12, color: "#64748b", marginTop: 4, lineHeight: 1.35 }}>
                            Rozsah: {getPlanRangeLabel(x)}
                          </div>
                        ) : null}


                      {x.obnovaPripravena ? (
                        <div style={{ marginTop: 4 }}>
                          <span style={renewalBadgeStyle(x.stavObnovy || "pripravena")}>Obnova: {renewalStatusLabel(x.stavObnovy || "pripravena")}</span>
                        </div>
                      ) : null}
                    </td>

                      <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", whiteSpace: "nowrap" }}>
                        <div>
                          <span style={badgeStyle(x.stav || "")}>{statusLabel(x.stav || "")}</span>
                            {x.rucneUpravenyTermin ? (
                              <span
                                style={{
                                  display: "inline-block",
                                  marginLeft: 6,
                                  padding: "3px 8px",
                                  borderRadius: 999,
                                  fontSize: 11,
                                  fontWeight: 700,
                                  border: "1px solid #fdba74",
                                  background: "#fff7ed",
                                  color: "#c2410c",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Ručně upraveno
                              </span>
                            ) : null}
                        </div>
                        {isPoTerminuZakazka(x, today) ? (
                          <div style={{ marginTop: 4 }}>
                            <span
                              style={{
                                display: "inline-block",
                                padding: "3px 8px",
                                borderRadius: 999,
                                fontSize: 11,
                                fontWeight: 700,
                                border: "1px solid #fecaca",
                                background: "#fef2f2",
                                color: "#991b1b",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Po termínu
                            </span>
                          </div>
                        ) : null}
                      </td>

                  <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", whiteSpace: "nowrap" }}>{x.datumVyfakturovani || "-"}</td>

                  <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", whiteSpace: "nowrap", fontWeight: 600 }}>{money(x?.soucty?.sDph)}</td>

                    <td style={{ padding: "10px 12px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", ...stickyActionColStyle }}>
                      {(() => {
                        const stav = String(x.stav || "").trim();
                        const typPece = String(x.typPece || "").trim();
                        const stavPredplatneho = String(x.stavPredplatneho || "").trim();
                        const stavObnovy = String(x.stavObnovy || "").trim();
                        const financniStav = String(x.financniStav || "").trim();

                        const jeNavaznaPece =
                          typPece === "predplatne" ||
                          typPece === "balicek" ||
                          typPece === "balicek_4x" ||
                          !!x.opakovana;

                        const canShowRenewal =
                            stavPredplatneho === "ceka_na_obnovu";

                        const canConfirmRenewal = !!x.obnovaPripravena;
                        const renewalConfirmed = stavObnovy === "potvrzena";

                        const canMarkDone =
                          stav !== "dokonceno" &&
                          (
                            stav !== "vyfakturovano" ||
                            jeNavaznaPece
                          ) &&
                          stavPredplatneho !== "ceka_na_obnovu" &&
                          stavPredplatneho !== "ceka_na_realizaci" &&
                          stavPredplatneho !== "vyprselo";

                        const doneTitle =
                          stavPredplatneho === "ceka_na_obnovu"
                            ? "Nejdřív je potřeba obnova"
                            : stavPredplatneho === "ceka_na_realizaci"
                              ? "Čeká se na zaplacení obnovy"
                              : stavPredplatneho === "vyprselo"
                                ? "Předplatné vypršelo"
                                : "Označit jako dokončeno";

                        const canShowPaid =
                          financniStav !== "zaplaceno" && (
                            (!jeNavaznaPece && (stav === "dokonceno" || stav === "vyfakturovano")) ||
                            (jeNavaznaPece && (
                              stavPredplatneho === "ceka_na_realizaci" ||
                              stavObnovy === "potvrzena" ||
                              stav === "vyfakturovano"
                            ))
                          );

                        const paidDisabled = financniStav === "zaplaceno";

                        const paidTitle =
                          financniStav === "zaplaceno"
                            ? "Zakázka už je označena jako zaplacená"
                            : jeNavaznaPece
                              ? "Označit zaplacení obnovy / předplatného"
                              : "Označit jako zaplacené";

                        const canShowInvoiced =
                          stav !== "vyfakturovano" && (
                            stav === "dokonceno" ||
                            financniStav === "zaplaceno"
                          );

                        return (
                          <div
                            style={{
                              display: "flex",
                              gap: 6,
                              flexWrap: "wrap",
                              alignItems: "flex-start",
                            }}
                          >
                            <button type="button" onClick={() => openDetail(x.id)} style={rowActionBtnStyle("primary")}>Detail</button>

                            {canShowRenewal ? (
                              <button type="button" onClick={() => prepareRenewal(x.id)} style={rowActionBtnStyle("secondary")}>Obnova</button>
                            ) : null}

                            {canConfirmRenewal ? (
                              <button
                                type="button"
                                onClick={() => markRenewalConfirmed(x.id)}
                                disabled={renewalConfirmed}
                                title={renewalConfirmed ? "Obnova už je potvrzená" : "Potvrdit obnovu"}
                                style={{
                                  ...rowActionBtnStyle("secondary"),
                                  opacity: renewalConfirmed ? 0.55 : 1,
                                  cursor: renewalConfirmed ? "not-allowed" : "pointer",
                                }}
                              >
                                Potvrdit obnovu
                              </button>
                            ) : null}

                            {canMarkDone ? (
                              <button
                                type="button"
                                onClick={() => markDone(x.id)}
                                title={doneTitle}
                                style={rowActionBtnStyle("secondary")}
                              >
                                Dokončeno
                              </button>
                            ) : null}

                            {canShowPaid ? (
                              <button
                                type="button"
                                onClick={() => markPaid(x.id)}
                                disabled={paidDisabled}
                                title={paidTitle}
                                style={{
                                  ...rowActionBtnStyle("secondary"),
                                  opacity: paidDisabled ? 0.55 : 1,
                                  cursor: paidDisabled ? "not-allowed" : "pointer",
                                }}
                              >
                                Zaplaceno
                              </button>
                            ) : null}

                            {canShowInvoiced ? (
                              <button
                                type="button"
                                onClick={() => markInvoiced(x.id)}
                                title="Označit jako vyfakturováno"
                                style={rowActionBtnStyle("secondary")}
                              >
                                Vyfakturováno
                              </button>
                            ) : null}
                          </div>
                        );
                      })()}
                    </td>
                </tr>
              ))}
            {!filteredItems.length && (
              <tr>
                <td colSpan="10" style={{ padding: 18, color: "#6b7280" }}>
                  Nic neodpovídá filtru.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {detail ? (
        <UdrzbaDetailZakazky
          item={detail}
          onClose={() => setDetail(null)}
          onSaved={handleDetailSaved}
        />
      ) : null}
    </div>
  );
}
